import createCrud from './crud';
import modules from './opportunities/index'

const getters = {

  isSigned: state => {
    return state.single.status == 'Signed'
  }
}

export default createCrud({
    resource: 'opportunities', modules, getters
  });